import { NgIf } from '@angular/common';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CobaltBannerComponent, CobaltBannerKind } from '@cae/cobalt-angular/components/banner';
import { Message } from '@core/models/message.model';
import { AppSettingsService } from '@core/services/app-settings/app-settings.service';
import { AuthB2CService } from 'common-web-core';

import { BannerService } from './banner.service';
import { HeaderService } from '../header/header.service';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.less'],
  standalone: true,
  imports: [
    CobaltBannerComponent,
    NgIf,
  ]
})
export class BannerComponent implements OnInit {
  public messageInfo = Message.empty();
  public messageType: CobaltBannerKind = 'success';

  private _destroyRef = inject(DestroyRef);

  constructor(
    private bannerService: BannerService,
    private headerService: HeaderService,
    private appSettingsService: AppSettingsService,
    private authB2cService: AuthB2CService
  ) { }

  public ngOnInit(): void {
    this.bannerService.message$
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((messageInfo: Message) => {
        if (messageInfo) {
          this.messageType = messageInfo.kind;
          this.messageInfo = messageInfo;
        }
      });
  }

  public closeMessage(): void {
    if (
      this.messageInfo.message ===
      this.appSettingsService.configuration.errorSettings
        .accessDeniedErrorMessage
    ) {
      this.authB2cService.logout();
    }
    this.messageInfo = Message.empty();
    this.bannerService.closed();
  }

  public showHelp(): void {
    this.headerService.showHelp();
  }
}
